"use client";
//#region packages/@mantine/core/src/components/Container/Container.module.css
var Container_module_default = { "root": "m_7485cace" };
//#endregion
export { Container_module_default as default };

//# sourceMappingURL=Container.module.mjs.map